// src/components/music/hooks/useMusicFilters.js

import { useState, useMemo } from 'react';

export const useMusicFilters = (music) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState('all');
  const [selectedAlbum, setSelectedAlbum] = useState('all');

  // Memoized album list
  const albums = useMemo(() => {
    return [...new Set(music.map(track => track.album).filter(Boolean))].sort();
  }, [music]);

  // Filter and Group Logic
  const filteredMusic = useMemo(() => {
    return music.filter((track) => {
      const matchesSearch =
        track.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (track.artist || 'The Asidors').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (track.album || '').toLowerCase().includes(searchQuery.toLowerCase());
      const matchesType = selectedType === 'all' || track.type === selectedType;
      const matchesAlbum = selectedAlbum === 'all' || track.album === selectedAlbum;
      return matchesSearch && matchesType && matchesAlbum;
    });
  }, [music, searchQuery, selectedType, selectedAlbum]);

  const groupedByAlbum = useMemo(() => {
    const grouped = filteredMusic.reduce((acc, track) => {
      const albumName = track.album || 'No Album';
      if (!acc[albumName]) {
        acc[albumName] = [];
      }
      acc[albumName].push(track);
      return acc;
    }, {});

    Object.keys(grouped).forEach(albumName => {
      grouped[albumName].sort((a, b) => {
        const trackA = parseInt(a.trackNumber) || 999;
        const trackB = parseInt(b.trackNumber) || 999;
        return trackA - trackB;
      });
    });
    return grouped;
  }, [filteredMusic]);

  return {
    filteredMusic,
    groupedByAlbum,
    albums,
    searchQuery,
    setSearchQuery,
    selectedType,
    setSelectedType,
    selectedAlbum,
    setSelectedAlbum
  };
};